export default __webpack_public_path__ + "static/media/second_empresa.903ff608.png";